// React
import { Fragment, memo, useEffect } from "react"

// API
import { useQuery } from "react-query"
import { SettingApi } from "api"
import { Api } from "./OrderReview/api"

// Components
import { ButtonGroup, Card, CardBody, Col, Input, InputGroup, Row, TabContent, TabPane } from "reactstrap"
import { ActionButton, CloseButton, DataStatus, FullCalendar, Section } from "components"
import { DepartureSection } from "./DepartureSection"
import { OrderReview } from "./OrderReview"

// Form
import { Controller, useFormContext, useWatch } from "react-hook-form"

// Functions
import { dateConvert, sweetAlert, toast } from "functions"

// Icons
import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa"
import { TbCalendarMinus, TbChevronLeft, TbChevronRight, TbCurrencyDollar, TbMinus, TbPlus, TbRotateClockwise, TbTicket } from "react-icons/tb"

// Third-Party Libraries
import useToggle from "@react-hook/toggle"
import { useNavigate } from "react-router-dom"

export const FormSection = ({ baseData, category, setting }) => {
  // Form
  const { control, getValues, setValue } = useFormContext()
  const page = useWatch({
    control,
    name: "page"
  })

  useEffect(() => window.scrollTo(0, 0), [page])

  const Inclusion = ({ detail2, detail3 }) => {
    // Hooks
    const [show, toggle] = useToggle(false, true)

    return (
      <div className="mb-3">
        <div className="text-editor" dangerouslySetInnerHTML={{ __html: detail2 }} />

        {detail3 && (
          <Fragment>
            <div className="fw-bold text-decoration-underline" style={{ cursor: "pointer" }} onClick={toggle}>{show ? "Read Less" : "Read More"}</div>
            {show && <div className="text-editor" dangerouslySetInnerHTML={{ __html: detail3 }} />}
          </Fragment>
        )}
      </div>
    )
  }

  function useCheckCart() {
    if (getValues("ticket").length === 0) {
      toast("error", "Error", "Please select minimum 1 Ticket")
    } else {
      setValue("page", 3)
    }
  }

  return (
    <Fragment>
      <Section className="text-center mb-3">
        <ButtonGroup className="rounded-pill shadow my-1">
          <NavItemData pageNumber={1}>
            <div className="d-flex align-items-center">
              <TbTicket size={16} />
              <div className="d-md-block d-none">
                <span className='align-middle ms-1'>SELECT TICKET</span>
              </div>
            </div>
          </NavItemData>
          <NavItemData pageNumber={2}>
            <div className="d-flex align-items-center">
              <TbCalendarMinus size={16} />
              <div className="d-md-block d-none">
                <span className='align-middle ms-1'>ARRIVAL DATE</span>
              </div>
            </div>
          </NavItemData>
          <NavItemData
            pageNumber={3}
            onClick={useCheckCart}
          >
            <div className="d-flex align-items-center">
              <TbCurrencyDollar size={16} />
              <div className="d-md-block d-none">
                <span className='align-middle ms-1'>CHECKOUT</span>
              </div>
            </div>
          </NavItemData>
        </ButtonGroup>

      </Section>

      <Section>
        <TabContent activeTab={page}>
          <TabPane tabId={1}>
            {page === 1 && (
              <Row className="justify-content-between align-items-stretch">
                <Col md={4}>
                  <Cart />
                </Col>

                <Col md={8}>
                  <div className="h6 text-white">.</div>

                  <Card style={{ minHeight: '50px' }}>
                    <CardBody style={{ minHeight: 500 }}>
                      {category.length === 0 ? (
                        <DataStatus>No data available</DataStatus>
                      ) : category.map((val, index) => {
                        // Variables
                        const image = val.image

                        const checkEven = value => {
                          // eslint-disable-next-line
                          return Boolean(value % 2 == 0)
                        }

                        return (
                          <section key={index} className={`${checkEven(index + 1) && "bg-light"}`}>
                            <Row className="align-items-center">
                              <Col lg={4} className="text-lg-start text-center mb-lg-0 align-self-start">
                                <img alt={val.name} className="img-fluid rounded" src={`${process.env.REACT_APP_BASE_URL}${val.image}`} />
                              </Col>
                              <Col lg>
                                <Inclusion detail2={val.detail2} detail3={val.detail3} />
                              </Col>
                            </Row>

                            <h5 className="text-center fw-bold">ADD TO YOUR CART</h5>

                            <Row className="justify-content-center">
                              {val.online_service.map((val, index) => (
                                <Col key={index} md={6} className="d-flex align-items-stretch">
                                  <ActionButton
                                    block
                                    color="primary"
                                    className="text-white mb-2"
                                    onClick={() => {
                                      const data = getValues("ticket")
                                      const checkIndex = data.findIndex(item => item.id === val.id)
                                      const checkData = data.find(item => item.id === val.id)

                                      if (checkIndex !== -1) {
                                        data.splice(checkIndex, 1, {
                                          ...checkData,
                                          pax: checkData.pax + 1
                                        })
                                      } else {
                                        data.push({
                                          ...val,
                                          service_name: val.name,
                                          name: category[0].name,
                                          image,
                                          choosed_service: val.id,
                                          pax: 1,
                                          price: parseFloat(val.price)
                                        })

                                        toast('success', `${val.name} added to cart`)
                                      }

                                      setValue("ticket", data)
                                    }}
                                  >
                                    <div>{val.name}</div>
                                    <div>IDR {parseFloat(val.price).toLocaleString('id-ID')}</div>
                                  </ActionButton>
                                </Col>
                              ))}
                            </Row>

                            {val.name === "FINNS DEPARTURE DAY PASS" && (
                              <Fragment>
                                <hr />

                                <Row className="justify-content-center">
                                  <Col md={5} className="text-center">
                                    <DepartureSection id={val.id} />
                                  </Col>
                                </Row>
                              </Fragment>
                            )}
                          </section>
                        )
                      })}

                      <ActionButton block color="gold" className="text-white" onClick={() => setValue("page", 2)}>BUY NOW</ActionButton>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </TabPane>
          <TabPane tabId={2}>
            {page === 2 && <CalendarSection />}
          </TabPane>
          <TabPane tabId={3}>
            {page === 3 && (
              <OrderReview
                setting={setting}
                is_departure={Boolean(category ? category[0]?.is_departure ?? 0 : 0)}
              />
            )}
          </TabPane>
        </TabContent>
      </Section>

      <section>
        <Terms baseData={baseData} />
      </section>

      <section>
        <div className="fixed-bottom bg-primary text-white">
          <SummarySection setting={setting} />
        </div>
      </section>

      <CodeChecker />
    </Fragment>
  )
}

function Cart() {
  // Form
  const { control, setValue } = useFormContext()
  const ticket = useWatch({
    control,
    name: "ticket"
  })

  return (
    <Fragment>
      <h6 className="text-center fw-bold">YOUR CART</h6>

      <section className="rounded border" style={{ minHeight: '90%' }}>
        {ticket.map((val, index) => (
          <div key={index} className="rounded mb-2 shadow position-relative">
            <div className="position-absolute top-0 end-0">
              <CloseButton
                onClick={() => {
                  sweetAlert({}).then(result => {
                    if (result.isConfirmed) {
                      // Variables
                      const data = [...ticket]

                      data.splice(index, 1)
                      setValue("ticket", data)
                    }
                  })
                }}
              />
            </div>

            <Row className="align-items-center px-3 py-2">
              <Col xs={4}>
                <img alt={val.name} src={`${process.env.REACT_APP_BASE_URL}${val.image}`} className="img-fluid rounded" />
              </Col>
              <Col xs={8}>
                <section>
                  <div className="fw-bold">{val.name}</div>
                  {val.service_name && <div className="fw-bold">({val.service_name})</div>}
                  <hr className="my-1" />
                  <div>Price : IDR {val.price.toLocaleString('id-ID')}</div>
                </section>

                <section>
                  <Controller
                    control={control}
                    name={`ticket[${index}].pax`}
                    render={({ field }) => (
                      <InputGroup>
                        <ActionButton
                          color="primary"
                          className="text-white"
                          onClick={() => {
                            if (ticket[index].pax === 1) {
                              sweetAlert({}).then(result => {                                
                                if (result.isConfirmed) {
                                  // Variables
                                  const data = [...ticket]

                                  data.splice(index, 1)
                                  setValue("ticket", data)
                                }
                              })
                            } else {
                              field.onChange(ticket[index].pax - 1)
                            }
                          }}
                        >
                          <TbMinus />
                        </ActionButton>

                        <Input value={ticket[index].pax} className="text-center" readOnly />

                        <ActionButton
                          color="primary"
                          className="text-white"
                          onClick={() => field.onChange(ticket[index].pax + 1)}
                        >
                          <TbPlus />
                        </ActionButton>
                      </InputGroup>
                    )}
                  />
                </section>
              </Col>
            </Row>
          </div>
        ))}
      </section>
    </Fragment>
  )
}

function CalendarSection() {
  // Form
  const { control, getValues, setValue } = useFormContext()

  return (
    <Controller
      control={control}
      name="booking_date"
      render={({ field }) => {
        return (
          <FullCalendar
            value={field.value}
            onClick={(val) => {
              sweetAlert({
                title: "",
                html: `<div>Please confirm you would like to select <br /><strong>${dateConvert(val).withDay.detail}?</strong></div>`,
                icon: null,
                confirmButtonText: "Yes - I'd like this date",
                cancelButtonText: "Change"
              }).then(res => {
                if (res.isConfirmed) {
                  field.onChange(dateConvert(val).default.format)
                  
                  if (getValues("ticket").length === 0) {
                    toast("error", "Error", "Please select minimum 1 Ticket")
                  } else {
                    setValue("page", 3)
                  }
                }
              })
            }}
          />
        )
      }}
    />
  )
}

function CodeChecker() {
  // Form
  const { control, setValue } = useFormContext()
  const ticket = useWatch({
    control,
    name: "ticket"
  })
  const _code = useWatch({
    control,
    name: "_code"
  })

  useEffect(() => {
    if (_code.length > 0) {
      const discount = ticket.reduce((acc, item) => {
        if (_code[0].promo.sub_type === "GLOBAL" || _code[0].promo.service_available.find(code => code.service_id === item.id)) {
          return acc += _code[0].discount_type === "PERCENTAGE" ? (item.price * (_code[0].amount / 100) * item.pax) : _code[0].amount
        }
    
        return acc
      }, 0)

      if (discount === 0) {
        Api.deletePromo(_code[0].id).finally(() => {
          toast("error", "Error", "The promo is not available for this packages, promo has been deleted")
          setValue("_code", [])
        })
      }
    }

    // eslint-disable-next-line
  }, [_code, ticket])

  return null
}

function NavItemData({
  pageNumber = 1,
  children,
  onClick
}) {
  // Form
  const { control, setValue } = useFormContext()
  const page = useWatch({
    control,
    name: "page"
  })

  return (
    <ActionButton
      color={`${page >= pageNumber ? "primary" : "flat-primary"}`}
      className={`rounded-pill px-5 ${page >= pageNumber ? "text-white" : "text-primary"}`}
      onClick={() => onClick ? onClick() : setValue("page", pageNumber)}
      style={{ marginLeft: pageNumber !== 1 && "-35px" }}
    >
      {children}
    </ActionButton>
  )
}

function SummarySection({ setting }) {
  // Hooks
  const navigate = useNavigate()

  // API
  const fetchInsurance = useQuery(['setting', 'personal_insurance'], SettingApi.personal_insurance)

  // Form
  const { control, setValue } = useFormContext()
  const _code = useWatch({
    control,
    name: "_code"
  })
  const page = useWatch({
    control,
    name: "page"
  })
  const qty_insurance = useWatch({
    control,
    name: "qty_insurance"
  })
  const ticket = useWatch({
    control,
    name: "ticket"
  })

  // Variables
  const totalPrice = ticket.reduce(
    (previousValue, { pax, price }) => previousValue + (pax * price), 0
  )
  const totalDiscount = () => {
    let discount = 0

    if (_code.length === 0) {
      discount = 0
    } else {
      discount = ticket.reduce((acc, item) => {
        if (_code[0].promo.sub_type === "GLOBAL" || _code[0].promo.service_available.find(code => code.service_id === item.id)) {
          return acc += _code[0].discount_type === "PERCENTAGE" ? (item.price * (_code[0].amount / 100) * item.pax) : _code[0].amount
        }
    
        return acc
      }, 0)
    }

    return totalPrice - discount
  }
  const tax = totalDiscount() * setting.tax_services
  const insurance_price = qty_insurance * (fetchInsurance.data ?? 0)
  const grandTotal = totalDiscount() + tax + insurance_price

  return (
    <div className="d-flex justify-content-between align-items-center py-1 px-3">
      <div className="flex-fill">
        <button
          className="btn btn-navigation btn-lg rounded-pill"
          onClick={() => {
            if (page === 1) {
              navigate('/')
            } else {
              setValue("page", page - 1)
            }
          }}
        >
          <div className="d-flex align-items-center text-primary">
            <TbChevronLeft size={16} />
            <div className="d-md-block d-none">
              <span className='align-middle ms-1'>Previous</span>
            </div>
          </div>
        </button>
      </div>

      <div className="flex-fill">
        {page > 1 && (
          <button
            className="btn btn-start-over btn-lg rounded-pill"
            onClick={() => {
              sweetAlert({
                title: "",
                html: `<div>Would you like to start over?</div>`,
                icon: null,
                confirmButtonText: "Okay",
                cancelButtonText: "Cancel"
              }).then(res => {
                if (res.isConfirmed) {
                  setValue("page", 1)
                  setValue("ticket", [])
                }
              })
            }}
          >
            <div className="d-flex align-items-center">
              <TbRotateClockwise size={16} />
              <div className="d-md-block d-none">
                <span className='align-middle ms-1'>Start Over</span>
              </div>
            </div>
          </button>
        )}
      </div>

      <div className="text-end flex-fill">
        <h4>Your Booking Total</h4>
        <h3 className="m-0">IDR {grandTotal.toLocaleString('id-ID')}</h3>
      </div>

      <div className="flex-fill text-end">
        {page < 3 && (
          <button
            className="btn btn-navigation btn-lg rounded-pill"
            onClick={() => {
              if (page !== 2) {
                setValue("page", page + 1)
              } else if (ticket.length === 0) {
                toast("error", "Error", "Please select minimum 1 Ticket")
              } else {
                setValue("page", 3)
              }
            }}
          >
            <div className="d-flex align-items-center text-primary">
              <div className="d-md-block d-none">
                <span className='align-middle me-1'>Next</span>
              </div>
              <TbChevronRight size={16} />
            </div>
          </button>
        )}
      </div>
    </div>
  )
}

const Terms = memo(function Terms({ baseData }) {
  // Hooks
  const [showTerms, toggleTerms] = useToggle(false, true)

  return (
    <Fragment>
      <ActionButton block color="primary" className="rounded-0 text-white" onClick={toggleTerms}>
        <div>Terms & Conditions</div>
        {showTerms ? <FaChevronCircleUp /> : <FaChevronCircleDown />}
      </ActionButton>

      <Section>
        {showTerms && <div dangerouslySetInnerHTML={{ __html: baseData.tc }} />}
      </Section>
    </Fragment>
  )
})